/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/eye-cross': {
    width: 28,
    height: 28,
    viewBox: '0 0 28 28',
    data: '<path pid="0" d="M16.506 16.515a3.545 3.545 0 11-5.011-5.011m9.525 9.525A11.9 11.9 0 0114 23.464c-8.273 0-13-9.455-13-9.455a21.804 21.804 0 015.98-7.02l14.04 14.04zM11.518 4.84c.814-.191 1.646-.286 2.482-.284 8.273 0 13 9.454 13 9.454a21.867 21.867 0 01-2.553 3.77L11.518 4.84zM1 1l26 26" _stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
